import { ServerInvitationFetch, ServerInvitationValidityFetch } from '@funnels/types';
import { INVITATION_STATUS } from '@funnels/constants';

export const MOCK_INVITATION_VALIDITY_FETCH_DATA: ServerInvitationValidityFetch = {
  id: 'invitation-1',
  mobile: '+61 444 111 222',
  status: INVITATION_STATUS.EXPIRED,
  applicationId: 'application-1',
  applicantId: 'applicant-2',
};

export const MOCK_INVITATION_FETCH_DATA: ServerInvitationFetch[] = [
  {
    id: 'invitation-1',
    mobile: '+61432456214',
    status: INVITATION_STATUS.ACCEPTED,
    isValid: true,
    applicationId: 'application-1',
    customerId: 'customer-2',
    applicantId: 'applicant-2',
    firstName: 'Nico',
    expiresOn: '2020-03-25T23:03:23.507Z',
  },
  {
    id: 'invitation-2',
    mobile: '+61432456233',
    status: INVITATION_STATUS.CANCELLED,
    isValid: true,
    applicationId: 'application-1',
    applicantId: 'applicant-3',
    firstName: 'J-free',
    expiresOn: '2020-03-25T23:03:23.507Z',
  },
  {
    id: 'invitation-3',
    mobile: '+61432456244',
    status: INVITATION_STATUS.EXPIRED,
    isValid: true,
    applicationId: 'application-1',
    applicantId: 'applicant-4',
    firstName: 'Andre',
    expiresOn: '2020-03-25T23:03:23.507Z',
  },
  {
    id: 'invitation-4',
    mobile: '+61432456299',
    status: INVITATION_STATUS.CANCELLED,
    isValid: true,
    applicationId: 'application-1',
    applicantId: 'applicant-5',
    firstName: 'Neville',
    expiresOn: '2020-03-24T23:03:23.507Z',
  },
  {
    id: 'invitation-5',
    mobile: '+61432456299',
    status: INVITATION_STATUS.PENDING,
    isValid: true,
    applicationId: 'application-1',
    applicantId: 'applicant-5',
    firstName: 'Neville',
    expiresOn: '2020-03-25T23:03:23.507Z',
  },
];
